import { render } from "./AddTranslation.vue?vue&type=template&id=dfde28f6&scoped=true"
import script from "./AddTranslation.vue?vue&type=script&lang=js"
export * from "./AddTranslation.vue?vue&type=script&lang=js"

import "./AddTranslation.vue?vue&type=style&index=0&id=dfde28f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfde28f6"]])

export default __exports__